import { Create } from "@/components/admin/create";
import { SimpleForm } from "@/components/admin/simple-form";
import { useGetIdentity, useGetOne } from "ra-core";
import { useSearchParams } from "react-router";
import { PaymentInputs } from "./PaymentInputs";
import type { Payment } from "../../types";

export const PaymentCreate = () => {
  const { identity } = useGetIdentity();
  const [searchParams] = useSearchParams();
  const duplicateFromId = searchParams.get("duplicate_from");
  const { data: source, isPending: sourceLoading } = useGetOne<Payment>(
    "payments",
    { id: duplicateFromId! },
    { enabled: !!duplicateFromId },
  );
  if (duplicateFromId && sourceLoading) return null;

  const directionParam = searchParams.get("direction");
  const direction =
    source?.direction ??
    (directionParam === "expense" ? "expense" : "income");

  const defaultValues = source
    ? {
        sales_id: identity?.id,
        direction: source.direction,
        amount: source.amount,
        category_id: source.category_id ?? undefined,
        contract_id: source.contract_id ?? undefined,
        vendor_name: source.vendor_name ?? undefined,
        comment: source.comment ?? undefined,
        status: "pending",
        planned_date: new Date().toISOString().slice(0, 10),
      }
    : {
        sales_id: identity?.id,
        direction,
        contract_id: searchParams.get("contract_id") ?? undefined,
        status: "pending",
        planned_date: new Date().toISOString().slice(0, 10),
        amount: 0,
      };

  return (
    <Create mutationMode="pessimistic" redirect="show">
      <SimpleForm className="max-w-3xl" defaultValues={defaultValues}>
        <PaymentInputs />
      </SimpleForm>
    </Create>
  );
};
